import axios from "core/services/axios";

import { nexaApiUrl } from "./urls";

import type { NexaMessage, NexaResumeResponse, NexaStoredMessage, NexaThreadSummary } from "./types";
import type { WireCreatedThread, WireResumeResponse, WireThreadSummary } from "./wire";
import { toResumeResponse, toThreadSummary } from "./wire";

const nexaUrl = nexaApiUrl;

export const fetchNexaThreads = async (): Promise<NexaThreadSummary[]> => {
  const { data } = await axios.get<{ threads: WireThreadSummary[] }>(nexaUrl("threads"));
  return (data?.threads ?? []).map(toThreadSummary);
};

export const createNexaThread = async (title?: string): Promise<string> => {
  const { data } = await axios.post<WireCreatedThread>(nexaUrl("threads"), title ? { title } : {});
  if (!data?.thread_id) throw new Error("Nexa AI: POST threads returned no thread_id");
  return data.thread_id;
};

export const resumeNexaThread = async (threadId: string): Promise<NexaResumeResponse> => {
  const { data } = await axios.get<WireResumeResponse>(nexaUrl(`threads/${threadId}/resume`));
  return toResumeResponse(data);
};

export const deleteNexaThread = async (threadId: string): Promise<void> => {
  await axios.post(nexaUrl(`threads/${threadId}/delete`), {});
};

export const restoreNexaThread = async (threadId: string): Promise<NexaThreadSummary> => {
  const { data } = await axios.post<WireThreadSummary>(nexaUrl(`threads/${threadId}/restore`), {});
  return toThreadSummary(data);
};

export const mapResumedMessages = (rows: NexaStoredMessage[] | undefined): NexaMessage[] =>
  (rows ?? []).map((row, i) => {
    const at = new Date(row.createdAt).getTime() || Date.now();
    const id = `resumed-${i}`;
    if (row.role === "user") return { id, role: "user", text: row.content, at };
    return {
      id,
      role: "assistant",
      at,
      phases: [],
      outcome: { kind: "answer", event: { event: "turn.answer", text: row.content, format: "markdown", sources: [] } },
    };
  });
